const parseToTimestamp = (input: string | Date | number | null | undefined): number => {
    let date: Date
  
    if (input === null || input === undefined) {
      date = new Date()
    } else if (typeof input === 'string') {
      date = new Date(Date.parse(input))
  
      const parts = input.split('.')
  
      if (parts.length === 3) {
        const day = parseInt(parts[0], 10)
        const month = parseInt(parts[1], 10) - 1
        const year = parseInt(parts[2], 10)
  
        date = new Date(year, month, day)
      }
    } else {
      date = new Date(input)
    }
  
    if (isNaN(date.getTime())) {
      throw new Error('Некорректная дата')
    }
  
    return date.getTime()
  }
  
  export default parseToTimestamp
  